// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { useMemo, useState } from 'react';
import { ThemeModeContext } from './theme/ThemeModeContext';
import { getAppTheme } from './theme/theme';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

function AppProviders() {
  const [mode, setMode] = useState(() => localStorage.getItem('theme_mode') || 'dark');

  const theme = useMemo(() => getAppTheme(mode), [mode]);

  const value = useMemo(
    () => ({
      mode,
      toggleColorMode: () => {
        setMode((prev) => {
          const next = prev === 'dark' ? 'light' : 'dark';
          localStorage.setItem('theme_mode', next);
          return next;
        });
      },
    }),
    [mode],
  );

  return (
    <ThemeModeContext.Provider value={value}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </ThemeModeContext.Provider>
  );
}

root.render(
  <React.StrictMode>
    <AppProviders />
  </React.StrictMode>
);
